import Head from 'next/head';
import { NextSeo } from 'next-seo';
import TermsDetail from '@cont/TermsAndConditions/TermsDetail';
import Layout from '@layout/index';

import {
  getTermsMenu,
  getTermsPageByKey
} from '@cont/TermsAndConditions/apiHelper';

const TermsPage = ({ termsData, termsMenuData }) => {
  if (!termsData) return null;
  const { seoTitle, seoDescription, url, content, sidebar } = termsData;
  const link = `https://unacademy.com/terms/${url}`;
  return (
    <>
      <NextSeo
        title={seoTitle}
        description={seoDescription}
        url={link}
        openGraph={{ title: seoTitle, description: seoDescription, url: link }}
      />
      <Head>
        <title>{seoTitle}</title>
      </Head>
      <TermsDetail
        isSidebar={sidebar}
        content={content}
        menuData={termsMenuData}
      />
    </>
  );
};

TermsPage.pageInfo = {
  name: 'Terms and Condition Page',
  isMWebSupported: true,
  layoutOptions: {
    hideSearch: true,
    hideIntercom: true,
    disableDarkMode: true
  }
};

export const getStaticProps = async ({ params: query }) => {
  const { id } = query;
  const promises = [];
  promises.push(getTermsPageByKey(id));
  promises.push(getTermsMenu());
  try {
    const [termsData, termsMenuData] = await Promise.all(promises);
    return {
      props: {
        termsData,
        termsMenuData
      },
      revalidate: 10 * 60
    };
  } catch (error) {
    return { notFound: true, revalidate: 60 };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

export default TermsPage;

TermsPage.Layout = Layout;
